import CustomButton from "components/CustomButton";
import { useFormik } from "formik";
import Summerizer from "./Summerizer";
import { AIContext } from "store/contexts/aiContext";
import TeamService from "services/TeamService";
import { useToasts } from "react-toast-notifications";
import { useTimelineContext } from "store/contexts/timelineContext";
import { useState } from "react";
import { useTeamActionContext } from "store/contexts/teamActionContext";
import { useDispatch, useSelector } from "react-redux";
import * as timelineActions from "reteamStore/actions";

const PostSummarizer = ({ data, type, isInnovationDashboard = false }) => {
  const [aiOption, setAiOption] = useState(2);
  const dispatch = useDispatch();
  const { total } = useSelector(
    (state) => state.todoListReducer
  );
  const { updatePost } = useTimelineContext();
  const { createNewPost } = useTeamActionContext();
  const [displayAIModal, setDisplayAI] = useState(false);
  const { addToast } = useToasts();

  const formik = useFormik({
    initialValues: {
      text: type === "text" ? data.data.content : data.data.text,
      attachment: null,
    },
  });

  const postSummaryOnTimeline = async (res) => {
    try {
      await TeamService.updateSummaryIntoPost(data.team.id, data.id, {
        summary: res.overallSummary,
      });

      const postCopy = { ...data };
      postCopy.data.summary = res.overallSummary;

      updatePost(postCopy);

      setDisplayAI(false);
    } catch (e) {
      addToast("Some error occurred.", {
        appearance: "error",
      });
    }
  };

  const createTodoFromActionItems = async (res) => {
    try {
      const response = await TeamService.createTodoFromActionItems({
        teamId: data.team.id,
        taskName: res.listName,
        tasks: res.actionItems.map((t) => t.text),
        priority: "",
        dueDate: "",
      });

      if(total !== "") {
        let todo = {...response.data.data.todo}
        dispatch(timelineActions.createList(todo));
      }

      var postData = {
        id: response.data.data.todo.id,
        content: res.listName,
      };
      createNewPost(
        postData,
        response.data.data.todo.team_post_id,
        response.data.data.todo.updated_at,
        { name: "todo-list", type_id: 16, tmpTeamId: data.team.id }
      );
    } catch (e) {
      console.log(e);
      addToast("Some error occurred.", {
        appearance: "error",
      });
    }
  };

  return (
    <>
      <AIContext.Provider
        value={{
          formik,
          setAiOption,
          aiOption,
          displayAIModal,
          setDisplayAI,
          postSummaryOnTimeline,
          createTodoFromActionItems,
          isInnovationDashboard,
          allowTodo: true,
          sOption: { ideaId: type === "brightidea" ? 1 : 0 },
          isStatusPost: type === "text",
        }}
      >
        <CustomButton
          onClick={() => setDisplayAI(true)}
          buttonClass="grad_btn summary-button"
        >
          Summarize
        </CustomButton>
        <Summerizer />
      </AIContext.Provider>
    </>
  );
};

export default PostSummarizer;
